/* eslint-disable eqeqeq */
import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import { connect } from 'react-redux';
import Alert from 'reactstrap/lib/Alert';
import { bindActionCreators } from 'redux';
import { Confirm, Grid, Segment } from 'semantic-ui-react';

import { CustomTooltip } from '../../../components';
import { filter, find, get, isEmpty, map, some } from '../../../utils/lodash';
import { putObjective } from '../../../store/actions';
import { getPageDisable } from '../../../utils';
import './activity.scss';
import ShowMoreText from 'react-show-more-text';
import ProjectText from '../../../components/projectText';
import WHITELIST_USERS from '../../../utils/activity/specialPermissionUsers';

class ActivityObjectiveComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      confirm: false,
      evalPlans: false,
      objectiveOne: null,
      objectiveTwo: null,
    };
  }

  renderObjectiveDomainOne() {
    const { objectiveOne, objectiveTwo } = this.state;
    let { outcomes, currentActivity } = this.props;

    const objectives = filter(outcomes, (o) => {
      if (
        (o.id == this.state.objectiveOne || o.isEnable) &&
        ((objectiveOne && objectiveOne === o.id) || objectiveTwo !== o.id) // if objective 1 eq objective 2 need to show
      ) {
        return o.policyId == currentActivity.primaryPolicyId;
      }
    });

    if (isEmpty(objectives)) return null;
    return map(objectives, (item, i) => (
      <option key={i} value={item.id}>
        {item.title}
      </option>
    ));
  }

  renderObjectiveDomainTwo() {
    const { objectiveOne, objectiveTwo } = this.state;
    let { outcomes, currentActivity } = this.props;
    const objectives = filter(outcomes, (o) => {
      if (
        (o.id == this.state.objectiveTwo || o.isEnable) &&
        ((objectiveTwo && objectiveTwo === o.id) || objectiveOne !== o.id) // if objective 1 eq objective 1 need to show
      ) {
        return o.policyId == currentActivity.secondaryPolicyId;
      }
    });
    if (isEmpty(objectives)) return null;
    return map(objectives, (item, i) => (
      <option key={i} value={item.id}>
        {item.title}
      </option>
    ));
  }

  // Only saved evaluation plans with recorded participant responses should
  // block an objective change - an empty/unused plan is safe to replace.
  hasRecordedResponses(objectiveId) {
    const { currentActivity } = this.props;
    if (!objectiveId) return false;

    return some(get(currentActivity, 'evaluationPlans', []), (plan) =>
      some(
        plan.evaluationQuestions,
        (question) =>
          question.objectiveId === objectiveId &&
          get(question, 'responseCounts.total', 0) > 0
      )
    );
  }

  async setObjectiveOne({ target }) {
    try {
      const { currentObjective, currentActivity, user } = this.props;
      // const isWhitelistOwner =
      //   currentActivity.ownerId === user.id &&
      //   WHITELIST_USERS.includes(get(currentActivity, 'owner.email'));

      const isWhitelistOwner = WHITELIST_USERS.includes(user.email);
      const isDuplicatedLinked =
        Boolean(currentActivity.duplicatedFromId) &&
        currentActivity.statusId === 1;

      if (
        currentActivity.isLinkedActivity &&
        !isWhitelistOwner &&
        !isDuplicatedLinked
      ) {
        return null;
      }

      const objectiveIdSelected = get(currentActivity, 'objective[0].id', null);

      if (this.hasRecordedResponses(objectiveIdSelected)) {
        this.toggleError();
      } else {
        if (this.isNewObjective(currentObjective[0])) {
          this.putObjective(target.value, 0);
        } else {
          this.setState(
            {
              confirm: true,
            },
            () => {
              this.objectiveIndex = 0;
              this.targetValue = target.value;
            }
          );
        }
        this.setState({ objectiveOne: target.value });
      }
    } catch (error) {
      // console.error('ActivityObjective -> setObjectiveOne -> error', error);
    }
  }

  async setObjectiveTwo({ target }) {
    try {
      const { currentObjective, currentActivity, user } = this.props;
      const isWhitelistOwner = WHITELIST_USERS.includes(user.email);
      const isDuplicatedLinked =
        Boolean(currentActivity.duplicatedFromId) &&
        currentActivity.statusId === 1;

      if (
        currentActivity.isLinkedActivity &&
        !isWhitelistOwner &&
        !isDuplicatedLinked
      ) {
        return null;
      }

      const objectiveIdSelected = get(currentActivity, 'objective[1].id', null);

      if (this.hasRecordedResponses(objectiveIdSelected)) {
        this.toggleError();
      } else {
        if (this.isNewObjective(currentObjective[1])) {
          this.putObjective(target.value, 1);
        } else {
          this.setState(
            {
              confirm: true,
            },
            () => {
              this.objectiveIndex = 1;
              this.targetValue = target.value;
            }
          );
        }
        this.setState({ objectiveTwo: target.value });
      }
    } catch (error) {
      // console.error('setObjectiveTwo -> error', error);
    }
  }

  toggleError() {
    this.setState(
      (prevState) => {
        return {
          evalPlans: !prevState.evalPlans,
        };
      },
      () => {
        this.form && this.form.reset();
      }
    );
  }

  isNewObjective(currentObjective) {
    try {
      if (isEmpty(currentObjective)) return true;
      if (currentObjective.tocKnown) return false;
      if (currentObjective.tocDo) return false;
      if (!isEmpty(currentObjective.evidence)) return false;

      return true;
    } catch (error) {
      // console.error('ValidateObjective -> error', error);
      throw error;
    }
  }

  getDescription(value) {
    if (isEmpty(value.outcome)) {
      return '-';
    } else {
      return value.outcome.description || '-';
    }
  }

  close = () => {
    this.setState({ confirm: false });
  };

  onConfirm = async () => {
    this.setState({ confirm: false }, () => {
      this.putObjective(this.targetValue, this.objectiveIndex);
    });
  };

  putObjective = async (targetValue, objectiveIndex) => {
    let { outcomes, putObjective } = this.props;
    const outcome = find(outcomes, (o) => {
      return o.id == targetValue;
    });
    if (isEmpty(outcome)) return null;
    await putObjective(
      'objective',
      {
        outcome,
        outcomeId: outcome.id,
      },
      objectiveIndex
    );
  };

  render() {
    const {
      t,
      user,
      helpTips,
      currentActivity,
      currentObjective,
      currentState,
    } = this.props;
    const { confirm, evalPlans } = this.state;
    const form = { descOne: '-', descTwo: '-' };
    const model = { objectiveOne: undefined, objectiveTwo: undefined };
    const isWhitelistOwner = WHITELIST_USERS.includes(user.email);
    const isSuperPermissionEdit =
      isWhitelistOwner &&
      currentActivity.statusId === 1 &&
      currentActivity.isLinkedActivity;

    try {
      const [objOne, objTwo] = currentObjective;
      if (!isEmpty(objOne)) {
        if (objOne.outcome.policyId == currentActivity.primaryPolicyId) {
          form.descOne = objOne.outcome.description;
          model.objectiveOne = objOne.outcomeId;
          this.setState({ objectiveOne: model.objectiveOne });
        } else {
          form.descTwo = objOne.outcome.description;
          model.objectiveTwo = objOne.outcomeId;
          this.setState({ objectiveTwo: model.objectiveTwo });
        }
      }
      if (!isEmpty(objTwo)) {
        if (objTwo.outcome.policyId == currentActivity.secondaryPolicyId) {
          form.descTwo = objTwo.outcome.description;
          model.objectiveTwo = objTwo.outcomeId;
          this.setState({ objectiveTwo: model.objectiveTwo });
        } else {
          form.descOne = objTwo.outcome.description;
          model.objectiveOne = objTwo.outcomeId;
          this.setState({ objectiveOne: model.objectiveOne });
        }
      }
    } catch (error) {
      // console.error('ActivityObjective -> render -> error', error);
    }

    const pageDisable = getPageDisable(currentActivity, user, currentState);

    const isSingleLinkedActivity = get(
      currentActivity,
      'isLinkedActivity',
      false
    );

    return (
      <AvForm
        ref={(c) => (this.form = c)}
        model={model}
        className="activity-form"
      >
        <Confirm
          open={evalPlans}
          confirmButton={null}
          onCancel={() => this.toggleError()}
          className="objective-warning"
          header={t('error_messages.action_not_allowed')}
          content={t('activity.objective.error.content')}
          size="tiny"
        />
        <Confirm
          open={confirm}
          onCancel={this.close}
          onConfirm={() => this.onConfirm()}
          className="objective-warning"
          header={t('common.warning')}
          content={t('activity.objective.warning.content')}
          confirmButton={t('actions.proceed')}
          size="tiny"
        />
        <Segment
          className="content-segment parent-objectives"
          disabled={pageDisable && !isSuperPermissionEdit}
        >
          <Grid>
            <Grid.Row>
              {/* goal */}
              <Grid.Column mobile={16} tablet={16} computer={8}>
                <div className="form-group-objective-margin-left">
                  <label className="goal-label">{t('common.goal')}</label>
                  <br />
                  <label className="objectiveGoal-title-new">
                    {currentActivity.goal ? (
                      currentActivity.goal
                    ) : (
                      <Alert color="warning">
                        {t('formulary.placeholder.select_a_goal')}
                      </Alert>
                    )}
                  </label>
                </div>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                <div className="form-group-objective-margin-right">
                  <label className="goal-label">
                    {t('formulary.goal_description')}
                  </label>
                  <br />
                  <ShowMoreText
                    lines={3}
                    more={t('common.read_more')}
                    less={t('common.read_less')}
                    anchorClass="show-more-less-clickable"
                    expanded={false}
                    truncatedEndingComponent={'... '}
                    className="pre-line"
                  >
                    <label className="objective-description-new">
                      {currentActivity.goalDescription
                        ? currentActivity.goalDescription
                        : '-'}
                    </label>
                  </ShowMoreText>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
        <Segment
          className="content-segment"
          disabled={pageDisable && !isSuperPermissionEdit}
        >
          <Grid>
            <Grid.Row>
              {/* domain one */}
              <Grid.Column mobile={16} tablet={16} computer={8}>
                <div className="form-group-select-objective-domain extra-top-bottom-margin">
                  <AvField
                    className="obj-inputs"
                    label={
                      <CustomTooltip
                        state={get(user, 'options.tips')}
                        contentObject={{
                          data: helpTips,
                          key: '21',
                        }}
                        position="bottom left"
                        wide="very"
                      >
                        <div className="required-star-label">
                          <ProjectText
                            defaultText={`${
                              currentActivity.primaryPolicy
                                ? currentActivity.primaryPolicy.policyName
                                : ''
                            } ${t('activity.objective.domain_objective')}`}
                            textId={4}
                            additionalTextValue={
                              currentActivity.primaryPolicy
                                ? currentActivity.primaryPolicy.policyName
                                : ''
                            }
                          />
                          {}
                        </div>
                      </CustomTooltip>
                    }
                    name="objectiveOne"
                    type="select"
                    onChange={(e) => this.setObjectiveOne(e)}
                    disabled={
                      isSingleLinkedActivity && !isWhitelistOwner
                        ? true
                        : currentActivity.goal
                          ? currentActivity.isLinkedActivity &&
                            !isWhitelistOwner
                            ? true
                            : false
                          : true
                    }
                    value={this.state.objectiveOne}
                  >
                    <option value="" disabled defaultValue>
                      {t('activity.objective.select_placeholder')}
                    </option>
                    {this.renderObjectiveDomainOne()}
                  </AvField>
                </div>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                <div className="objective-description-domain extra-top-bottom-margin">
                  <label>{t('formulary.description')}</label>

                  <label className="objective-description">
                    {form.descOne}
                  </label>
                </div>
              </Grid.Column>
            </Grid.Row>
            <div className="bottom-divider"></div>
            {/*domain two */}
            {!currentActivity.secondaryPolicyId ? null : (
              <Grid.Row>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <div className="form-group-select-objective-domain extra-top-margin">
                    <AvField
                      className="obj-inputs"
                      label={
                        <CustomTooltip
                          state={get(user, 'options.tips')}
                          contentObject={{
                            data: helpTips,
                            key: '22',
                          }}
                          position="bottom left"
                          wide="very"
                        >
                          <div className="required-star-label">
                            <ProjectText
                              defaultText={`${
                                currentActivity.secondaryPolicy
                                  ? currentActivity.secondaryPolicy.policyName
                                  : ''
                              } ${t('activity.objective.domain_objective')}`}
                              textId={4}
                              additionalTextValue={
                                currentActivity.secondaryPolicy
                                  ? currentActivity.secondaryPolicy.policyName
                                  : ''
                              }
                            />
                          </div>
                        </CustomTooltip>
                      }
                      name="objectiveTwo"
                      type="select"
                      onChange={(e) => this.setObjectiveTwo(e)}
                      disabled={
                        isSingleLinkedActivity && !isWhitelistOwner
                          ? true
                          : currentActivity.goal
                            ? currentActivity.isLinkedActivity &&
                              !isWhitelistOwner
                              ? true
                              : currentObjective && currentObjective.length
                                ? false
                                : true
                            : true
                      }
                      value={this.state.objectiveTwo}
                    >
                      <option value="" disabled defaultValue>
                        {t('activity.objective.select_placeholder')}
                      </option>
                      {this.renderObjectiveDomainTwo()}
                    </AvField>
                  </div>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <div className="objective-description-domain extra-top-margin">
                    <label>{t('formulary.description')}</label>

                    <label className="objective-description">
                      {form.descTwo}
                    </label>
                  </div>
                </Grid.Column>
              </Grid.Row>
            )}
          </Grid>
        </Segment>
      </AvForm>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.activity,
    outcomes: state.extra.outcomes,
    user: state.authentication.user,
    helpTips: state.extra.activityHelpTips,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      putObjective,
    },
    dispatch
  );
};

let ActivityObjective = withTranslation()(ActivityObjectiveComponent);
ActivityObjective = connect(
  mapStateToProps,
  mapDispatchToProps
)(ActivityObjective);

export { ActivityObjective };
